var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import Select from "@/components/ui/select/Select.vue";
import { computed, onMounted, ref, watch } from "vue";
import { fetchDefaultPeriod } from "./api";
import { usePeriods } from "./use-periods";
export default /*@__PURE__*/ _defineComponent({
    __name: 'PeriodSelector',
    props: {
        modelValue: { type: Object, required: false },
        tab: { type: String, required: false }
    },
    emits: ["update:modelValue", "change"],
    setup(__props, { expose: __expose, emit: __emit }) {
        var _a;
        __expose();
        const props = __props;
        // Emits
        const emit = __emit;
        // Composables
        const { periods, loadPeriods, clearCache } = usePeriods();
        // Local state - no initial value until backend responds
        const selectedPeriodKey = ref(((_a = props.modelValue) === null || _a === void 0 ? void 0 : _a.key) || "");
        // Variable to hold the actual default period from backend
        const backendDefaultPeriod = ref(null);
        // Computed properties
        const periodOptions = computed(() => {
            return periods.value.map((period) => ({
                label: period.label,
                value: period.key,
            }));
        });
        // Watch for selectedPeriodKey changes and emit the corresponding Period object
        watch(selectedPeriodKey, (newKey) => {
            if (newKey && periods.value.length > 0) {
                const period = periods.value.find((p) => p.key === newKey);
                if (period) {
                    emit("update:modelValue", period);
                    emit("change", period);
                }
            }
        });
        // Watch for external model changes
        watch(() => props.modelValue, (newPeriod) => {
            if (newPeriod && periods.value.length > 0 && newPeriod.key !== selectedPeriodKey.value) {
                const foundPeriod = periods.value.find((p) => p.key === newPeriod.key);
                if (foundPeriod) {
                    selectedPeriodKey.value = newPeriod.key;
                }
            }
        });
        // Load periods on mount
        onMounted(() => __awaiter(this, void 0, void 0, function* () {
            // Get default period from backend first
            try {
                backendDefaultPeriod.value = yield fetchDefaultPeriod();
                // If no model value was provided, use the backend default period
                if (!props.modelValue) {
                    selectedPeriodKey.value = backendDefaultPeriod.value.key;
                    emit("update:modelValue", backendDefaultPeriod.value);
                    emit("change", backendDefaultPeriod.value);
                }
            }
            catch (error) {
                console.warn('Failed to fetch default period from backend, using fallback');
                // Keep the original fallback logic
            }
            yield loadPeriods(props.tab);
            // After loading periods, check if the current selected period exists
            if (periods.value.length > 0) {
                const currentPeriodExists = periods.value.some((p) => p.key === selectedPeriodKey.value);
                // Only update to the most recent period if the current one doesn't exist
                if (!currentPeriodExists) {
                    // Prefer backend default if available, otherwise use most recent
                    const preferredPeriod = backendDefaultPeriod.value || periods.value[0];
                    selectedPeriodKey.value = preferredPeriod.key;
                    emit("update:modelValue", preferredPeriod);
                    emit("change", preferredPeriod);
                }
            }
        }));
        watch(() => props.tab, (newVal) => __awaiter(this, void 0, void 0, function* () {
            clearCache();
            yield loadPeriods(props.tab);
            // After loading periods, check if the current selected period exists
            if (periods.value.length > 0) {
                const currentPeriodExists = periods.value.some((p) => p.key === selectedPeriodKey.value);
                // Only update to the most recent period if the current one doesn't exist
                if (!currentPeriodExists) {
                    // Prefer backend default if available, otherwise use most recent
                    const preferredPeriod = backendDefaultPeriod.value || periods.value[0];
                    selectedPeriodKey.value = preferredPeriod.key;
                    emit("update:modelValue", preferredPeriod);
                    emit("change", preferredPeriod);
                }
            }
        }));
        const __returned__ = { props, emit, periods, loadPeriods, clearCache, selectedPeriodKey, backendDefaultPeriod, periodOptions, Select };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
